import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { TransitionGroup } from "react-transition-group";
import { t } from "ttag";

import { CSSTransitionWithRef } from "../../../components/CssTransition";
import { IBasket, IWishListLine } from "../../../models/catalogue";
import { IProductAPIURL } from "../../../models/nominals";
import { WishListLine } from "../BasketLine/WishListLine";

type IProps = Immutable<{
    lines: readonly IWishListLine[];
    removeWishlistLine: (lineURL: string) => Promise<IBasket>;
}> & {
    addBasketLine?: (
        productURL: IProductAPIURL,
        qty?: number,
    ) => Promise<IBasket>;
};

export const WishListLines = (props: IProps): React.ReactNode => {
    const isEmpty = props.lines.length <= 0;
    const classes = classNames({
        "wishlist-lines__content": true,
        // TODO(i18n): Consider if BEM modifier class names should remain in English for consistency with CSS, or be translatable
        "wishlist-lines__content--empty": isEmpty,
    });
    return (
        <div className={classes}>
            {isEmpty && <p>{t`This list is empty.`}</p>}
            <TransitionGroup>
                {props.lines.map((line) => (
                    <CSSTransitionWithRef
                        key={line.url}
                        classNames="transition--fade"
                        timeout={{ exit: 500, enter: 500 }}
                    >
                        <WishListLine {...props} line={line} />
                    </CSSTransitionWithRef>
                ))}
            </TransitionGroup>
        </div>
    );
};
